export function useWeglot() {
  const { getWeglot } = useStoreCustomer()
  const { data: weglot } = getWeglot()

  const insertWeglotScript = (key: string) => {
    const script = document.createElement('script')
    script.src = 'https://cdn.weglot.com/weglot.min.js'
    script.type = 'text/javascript'
    script.async = true
    document.head.appendChild(script)
    script.onload = () => {
      // @ts-expect-error Weglot js lib
      Weglot.initialize({
        api_key: key,
        hide_switcher: true,
        excluded_blocks: [
          {
            value: '.weglot-ignore'
          }
        ]
      })
    }
  }
  watch(weglot, (newValue) => {
    if (newValue && newValue.api_key) {
      insertWeglotScript(newValue.api_key)
    }
  })

  const refreshWeglot = () => {
    // @ts-expect-error Weglot js lib
    if (typeof Weglot !== 'undefined') Weglot?.addNodes()
  }

  const observer = ref<MutationObserver | null>(null)

  onMounted(() => {
    observer.value = new MutationObserver(refreshWeglot)
    observer.value.observe(document.body, { childList: true, subtree: true })
  })

  onUnmounted(() => {
    observer.value?.disconnect()
  })
}
